<ion-toolbar>
  <ion-row   class="toolbar-row">
    <ion-col>
      <div *ngIf="category==''" class="ratings-label">
        {{'AREA_MANAGEMENT.RATINGS'|translate}}
      </div>
      <div *ngIf="category!=''" class="ratings-label">
        {{'REPORT_DASHBOARD.SELECT_SITE'|translate}} ({{category}})
      </div>
      <div class="close-div">
        <ion-icon (click)="dismiss()" class="close-icon" name="close-outline"></ion-icon>
      </div>
    </ion-col>
  </ion-row>
</ion-toolbar>
<ion-toolbar *ngIf="category!=''">
  <ion-row style="margin-top:-16px;">
    <form style="width: 100%;
    margin: 10px;" [formGroup]="searchForm">
      <formly-form [model]="model" [fields]="fields" [options]="options" [form]="searchForm"></formly-form>
    </form>
  </ion-row>
</ion-toolbar>
<ion-content class="content-background">
  <ion-list *ngIf="category==''" lines="none" class="toolbar-row">
    
    <div *ngFor="let item of allRatingList,let i=index" (click)="openDetailsPage(item)" class="ion-activatable ripple-parent rating_list">
      <ion-row class="rating_list_first_row">
        <ion-col class="ion-align-self-center">
          <div class="rating_list_id">
            {{item.area_name}}
          </div>
          <div class="rating_list_area_name">
            {{item.zone_name}}
          </div>
          <div class="rating_list_date">
            {{item.month_and_year}}
          </div>
        </ion-col>
      </ion-row>
      <ion-row class="rating_list_second_row">
        <ion-col class="ion-align-self-center">
          <div class="rating_list_average_rating">
            {{'RATING.AVG_RATING'|translate}}:
          </div>
          <div class="rating_list_float_left">
            <div *ngIf="item.avg_rating>=0 && item.avg_rating<=1">
              <img class="rating_list_star_size" src="assets/img/rapid-tour/selected_star.svg"/>
              <img class="rating_list_star_size" src="assets/img/rapid-tour/unselected_star.svg"/>
              <img class="rating_list_star_size" src="assets/img/rapid-tour/unselected_star.svg"/>
              <img class="rating_list_star_size" src="assets/img/rapid-tour/unselected_star.svg"/>
              <img class="rating_list_star_size" src="assets/img/rapid-tour/unselected_star.svg"/>
            </div>
            <div *ngIf="item.avg_rating>1 && item.avg_rating<=2">
              <img class="rating_list_star_size" src="assets/img/rapid-tour/selected_star.svg"/>
              <img class="rating_list_star_size" src="assets/img/rapid-tour/selected_star.svg"/>
              <img class="rating_list_star_size" src="assets/img/rapid-tour/unselected_star.svg"/>
              <img class="rating_list_star_size" src="assets/img/rapid-tour/unselected_star.svg"/>
              <img class="rating_list_star_size" src="assets/img/rapid-tour/unselected_star.svg"/>
            </div>
            <div *ngIf="item.avg_rating>2 && item.avg_rating<=3">
              <img class="rating_list_star_size" src="assets/img/rapid-tour/selected_star.svg"/>
              <img class="rating_list_star_size" src="assets/img/rapid-tour/selected_star.svg"/>
              <img class="rating_list_star_size" src="assets/img/rapid-tour/selected_star.svg"/>
              <img class="rating_list_star_size" src="assets/img/rapid-tour/unselected_star.svg"/>
              <img class="rating_list_star_size" src="assets/img/rapid-tour/unselected_star.svg"/>
            </div>
            <div *ngIf="item.avg_rating>3 && item.avg_rating<=4">
              <img class="rating_list_star_size" src="assets/img/rapid-tour/selected_star.svg"/>
              <img class="rating_list_star_size" src="assets/img/rapid-tour/selected_star.svg"/>
              <img class="rating_list_star_size" src="assets/img/rapid-tour/selected_star.svg"/>
              <img class="rating_list_star_size" src="assets/img/rapid-tour/selected_star.svg"/>
              <img class="rating_list_star_size" src="assets/img/rapid-tour/unselected_star.svg"/>
            </div>
            <div *ngIf="item.avg_rating>4 && item.avg_rating<=5">
              <img class="rating_list_star_size" src="assets/img/rapid-tour/selected_star.svg"/>
              <img class="rating_list_star_size" src="assets/img/rapid-tour/selected_star.svg"/>
              <img class="rating_list_star_size" src="assets/img/rapid-tour/selected_star.svg"/>
              <img class="rating_list_star_size" src="assets/img/rapid-tour/selected_star.svg"/>
              <img class="rating_list_star_size" src="assets/img/rapid-tour/selected_star.svg"/>
            </div>
          </div>
          <div class="rating_list_float_right">
            <ion-icon class="rating_list_right_arrow" name="chevron-forward-outline"></ion-icon>
          </div>
        </ion-col>
      </ion-row>
      <ion-ripple-effect></ion-ripple-effect>
    </div>
    <div *ngIf="allRatingList.length==0" style="margin-top:100px;text-align:center;font-size:14px;color:black;">
      {{'RATING.NO_RECORDS_FOUND'|translate}}
    </div>
  </ion-list>

  <ion-grid *ngIf="category!=''">
    <div *ngIf="areaNameList.length>0" style="margin-top:-30px;">
      <ion-row class="shine_row_margin" *ngFor="let item of areaNameList,let i=index">
        <ion-col size="12" class="ion-align-self-center">
          <div style="float:left;">
            <ion-label [ngClass]="{'select-area':item.selected, 
            'unselect-area' : !item.selected }">{{item.name}}</ion-label>
          </div>
          <div style="float:right;">
            <ion-icon *ngIf="item.selected" (click)="selectAreaName(item,i)" style="border-radius:4px;height:18px;width:18px;background:#007382;color:#FFFFFF;" name="checkmark-outline"></ion-icon>
            <ion-icon *ngIf="!item.selected" (click)="selectAreaName(item,i)" style="border-radius:4px;color:#007382;height:18px;width:18px;" name="square-outline"></ion-icon>
          </div>
        </ion-col>
      </ion-row>
    </div>
    
  </ion-grid>

</ion-content>
<ion-footer *ngIf="category==''">
  <ion-row>
    <ion-col (click)="ratingDetails('sort')" class="ion-text-center ion-align-self-center ion-activatable ripple-parent">
      <ion-chip>
        <ion-icon class="footer-icon" name="funnel-outline"></ion-icon>
        <ion-label class="footer-label">{{'RATING.SORT'|translate}}</ion-label>
      </ion-chip>
      <ion-ripple-effect></ion-ripple-effect>
    </ion-col>
    <ion-col size="1" class="ion-text-center ion-align-self-center">
        <div class="vertical_line"></div>
    </ion-col>
    <ion-col (click)="ratingDetails('filter')" class="ion-text-center ion-align-self-center ion-activatable ripple-parent">
      <ion-chip>
        <ion-icon class="footer-icon" name="filter-outline"></ion-icon>
        <ion-label class="footer-label">{{'QR_MANAGEMENT.FILTER'|translate}}({{allRatingList.length}})</ion-label>
      </ion-chip>
      <ion-ripple-effect></ion-ripple-effect>
    </ion-col>
  </ion-row>
</ion-footer>

<ion-footer *ngIf="category!=''" style="background:#007382;">
  <ion-row>
    <ion-col style="padding:20px;" (click)="dismiss()" class="ion-text-center ion-align-self-center ion-activatable ripple-parent">
      <ion-label style="color:white;font-weight: 16px;">{{'ADD_QR.BTN_CANCEL'|translate}}</ion-label>
      <ion-ripple-effect></ion-ripple-effect>
    </ion-col>
    
    <ion-col style="padding:20px;"(click)="submit()" class="ion-text-center ion-align-self-center ion-activatable ripple-parent">
      <ion-label style="font-weight:600;color:white;font-weight: 16px;">{{'VPC.BTN_SUBMIT'|translate}}</ion-label>
      <ion-ripple-effect></ion-ripple-effect>
    </ion-col>
  </ion-row>
</ion-footer>
